import { createReducer, on } from '@ngrx/store';

import { AuthActions } from '../actions/auth.actions';
import { Car } from 'src/app/public/car/models/car.model';


export interface AuthState {
    loggedIn: boolean;
    userId: string;
    token: string;
    message: string;
    fetching: boolean;
}


export const initialAuthData: AuthState = {
    loggedIn: false,
    userId: 'ff fffg fgfgf',
    token: '',
    message: '',
    fetching: false
};

export const authReducer = createReducer(
    
    initialAuthData,

    on( AuthActions.loginSubmit,
        AuthActions.signupSubmit,   
        (state) => {
            return {
                ...state,
                fetching: true
            };
        }
    ),

    on( AuthActions.loginResult, (state, action) => {
            return {
                ...state, 
                message: action.message,
                fetching: false
            };
        }
    ),
    on( AuthActions.signupResult, (state, action) => {
            return {
                ...state,
                message: action.message,
                fetching: false 
            };
        }
    ),
    on( AuthActions.recoverPasswordResult, (state, action) => {
            return {
                ...state,
                message: action.message 
            };
        }
    ),
    on( AuthActions.updatePasswordResult, (state, action) => {
            return {
                ...state,
                message: action.message 
            };
        }
    ),
    on( AuthActions.authSuccess, (state, action) => {
        //localStorage.setItem("token", action.token);
        console.log('dfdf fdfddfd fffdfd')
            return {
                ...state,
                loggedIn: true,
                token: action.token!,
                userId: action.userId!,
                message: "",
                fetching: false
            };
        }
    ),

    on( AuthActions.authResult, (state, action) => {
        //localStorage.setItem("token", action.token);
            return {
                ...state,
                loggedIn: action.loggedIn,
                token: action.token!,
                userId: action.userId!,
                message: "",
                fetching: false
            };
        }
    ),

    on( AuthActions.logoutSubmit, (state) => {
        //localStorage.removeItem("token");
            return {
                ...state,
                loggedIn: false,
                token: '',
                message: "",
                fetching: false
            };
        }
    ),
    //on(reset, (state) => 0)
);


// selectors
export const selectLoggedIn = (state: AuthState) => state.loggedIn;
export const selectLoggedUserId = (state: AuthState) => state.userId;
export const selectToken = (state: AuthState) => state.token;
export const selectFetching = (state: AuthState) => state.fetching;


// utility functions
const addCar = ( cars: Car[], newCar: Car ) => [...cars, newCar];

const updateCar = ( cars: Car[],  changes: Car ) => 
    cars.map ( car => {
        return car.carId === changes.carId 
            ? Object.assign({}, car, changes)
            : car ;
    });

const deleteCar = ( cars: Car[], carId: string ) =>  cars.filter(car => carId !== car.carId);